<div fxLayout="row" fxLayoutAlign="space-around" style="padding-bottom: 20px;">
    <button #deactivateButton fxFlex="40" (click)="openDeactivateDialog()" class="btn btn-secondary">
        {{!selectedSubscriber?.deactivatedInd ? 'Deactivate' : 'Reactivate'}} Member Account
    </button>
</div>
<kendo-dialog
    *ngIf="dialogOpened"
    [title]="(!selectedSubscriber?.deactivatedInd ? 'Deactivate' : 'Rectivate') + ' Member Account'"
    (close)="closeDeactivateDialog(false)"
    [minWidth]="250"
    [width]="450"
>
    <p style="color: red; font-style:italic; font-weight: bold; text-align: center; font-size: large;">
        Are you sure you want to {{!selectedSubscriber?.deactivatedInd ? 'deactivate' : 'reactivate'}} the following account?
    </p>
    
    <p><strong>Name: </strong>{{selectedSubscriber?.firstName}} {{ selectedSubscriber?.lastName}}</p>
    <p><strong>SSN: </strong>{{ selectedSubscriber?.SSN}}</p>
    <p><strong>Birthday: </strong>{{ selectedSubscriber?.birthDate.toISOString().split('T')[0]}} </p>
    <p><strong>Member Type: </strong>{{ selectedSubscriber?.memberType}} </p>
    <p><strong>Employer Name: </strong>{{ selectedSubscriber?.employerName}} </p>
    <p style="text-align: center;" *ngIf="selectedSubscriber?.isSubscriberInd">
       {{!selectedSubscriber?.deactivatedInd ? 'Deactivating' : 'Reactivating'}} subscriber account will apply to all dependents on this account.
    </p>
    <p style="text-align: center;" *ngIf="!selectedSubscriber?.isSubscriberInd && selectedSubscriber.deactivatedInd">
       Reactivating member account requires the subscriber account to be active.
    </p>
    <kendo-dialog-actions>
        <button kendoButton (click)="closeDeactivateDialog(false)" class="btn btn-light">No</button>
        <button kendoButton (click)="closeDeactivateDialog(true)" class="btn btn-primary">
            {{!selectedSubscriber?.deactivatedInd ? 'Deactivate' : 'Reactivate'}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>